<template lang="pug">
aside-modal(id="zoneModal", width="w-xxxl", :loading="loading")
    span(slot="header-text") {{ zoneExists ? 'Update' : 'Create' }} Zone
    div.p-a(slot="body")
        form(id="zoneForm")
            fieldset(:disabled="loading")
                div.md-form-group
                    input.md-input(
                        type="text",
                        v-model="zone.name",
                        :readonly="!canManageZone"
                        required
                    )
                    label Name

                div.md-form-group
                    label {{ trans('general.outlets') }}
                    multiselect(
                        v-model="zone.outlets",
                        label="name",
                        track-by="id",
                        placeholder="Type to search",
                        :options="outletList",
                        :multiple="true",
                        :close-on-select="false",
                        :hide-selected="false",
                        :max-height="400",
                        :limit="30",
                        :loading="outlets_loading"
                        @search-change="loadOutlets"
                        :disabled="!canManageZone"
                    )

    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-zone')"
        v-if="canManageZone"
    ) 
        v-loading(loader="save-zone") Save
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    data() {
        return {
            zone: null,
            outletList: [],
            outlets_loading: false,
        };
    },

    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        loading() {
            return this.onLoading('fetch-zone') || this.onLoading('save-zone');
        },

        zoneExists() {
            return this.zone.id !== null;
        },

        canManageZone() {
            return Auth.hasPermissionTo('franchise_manage_zone');
        },
    },

    created() {
        this.zone = this.newZone();
    },

    mounted() {
        this.loadOutlets();
        this.registerEvent();
    },

    methods: {
        ...mapActions('zone', ['getZone', 'updateZone', 'createZone']),

        newZone() {
            return {
                id: null,
                name: null,
                outlets: [],
            };
        },

        toggleModal(action) {
            $('#zoneModal').modal(action);
        },

        getOultetList() {
            let api = Laroute.route('franchise.vue.outlets');
            this.$http.get(api).then(response => {
                this.outlets = response.data.data;
            });
        },

        loadOutlets: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.outlets');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.outlets_loading = true;
            this.$http.get(api, options).then(response => {
                this.outletList = response.data.data;
                this.outlets_loading = false;
            });
        }, 500),

        registerEvent() {
            this.$on('show-zone', id => {
                if (this.loading) return;

                if (id === null) {
                    this.zone = this.newZone();
                    this.toggleModal('show');
                } else {
                    this.getZone(id)
                        .then(res => {
                            this.toggleModal('show');
                            this.zone = _.pick(res.data, [
                                'id',
                                'name',
                                'outlets',
                            ]);
                        })
                        .catch(err => {
                            this.showApiError(err);
                        });
                }
            });
        },

        submit() {
            /** Promise */
            let save;

            if (!this.validateForm('zoneForm')) return;

            const outlets = this.zone.outlets.map(p => p.id);

            const zone = Object.assign(_.pick(this.zone, ['id', 'name']), {
                outlets,
            });

            if (!this.zoneExists) {
                save = this.createZone(zone);
            } else {
                save = this.updateZone(zone);
            }

            save.then(res => {
                this.showToastrSuccess();

                if (this.zoneExists) {
                    this.toggleModal('hide');
                } else {
                    this.zone = this.newZone();
                }

                this.$emit('zone-saved');
            }).catch(err => {
                this.showApiError(err);
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/zone/zone-form.vue